/*
 * 2007-2015 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/afl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 *  @author PrestaShop SA <contact@prestashop.com>
 *  @copyright  2007-2015 PrestaShop SA
 *  @license    http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 *  International Registered Trademark & Property of PrestaShop SA
 */

//global variables
var serialScrollNbImagesDisplayed;
var selectedCombination = [];
var globalQuantity = 0;
var colors = [];
var original_url = window.location + "";
var first_url_check = true;
var firstTime = true;

var unsortedList = $("#selectStoreModal .store-option");
var sortedList = $("#selectStoreModal .store-option");

$.fn.refresh = function () {
	return $(this.selector);
};

/* Retro compat from product.tpl */
if (typeof customizationFields !== "undefined" && customizationFields) {
	var customizationFieldsBk = customizationFields;
	customizationFields = [];
	var j = 0;
	for (var i = 0; i < customizationFieldsBk.length; ++i) {
		var key =
			"pictures_" +
			parseInt(id_product) +
			"_" +
			parseInt(customizationFieldsBk[i]["id_customization_field"]);
		customizationFields[i] = [];
		customizationFields[i][0] =
			parseInt(customizationFieldsBk[i]["type"]) == 0
				? "img" + i
				: "textField" + j++;
		customizationFields[i][1] =
			parseInt(customizationFieldsBk[i]["type"]) == 0 &&
			customizationFieldsBk[i][key]
				? 2
				: parseInt(customizationFieldsBk[i]["required"]);
	}
}

if (typeof combinationImages !== "undefined" && combinationImages) {
	combinationImagesJS = [];
	combinationImagesJS[0] = [];
	var k = 0;
	for (var i in combinationImages) {
		combinationImagesJS[i] = [];
		for (var j in combinationImages[i]) {
			var id_image = parseInt(combinationImages[i][j]["id_image"]);
			if (id_image) {
				combinationImagesJS[0][k++] = id_image;
				combinationImagesJS[i][j] = [];
				combinationImagesJS[i][j] = id_image;
			}
		}
	}

	if (
		typeof combinationImagesJS[0] !== "undefined" &&
		combinationImagesJS[0]
	) {
		var array_values = [];
		for (var key in arrayUnique(combinationImagesJS[0]))
			array_values.push(combinationImagesJS[0][key]);
		combinationImagesJS[0] = array_values;
	}
	combinationImages = combinationImagesJS;
}

if (typeof combinations !== "undefined" && combinations) {
	combinationsJS = [];
	var k = 0;
	for (var i in combinations) {
		globalQuantity += combinations[i]["quantity"];
		combinationsJS[k] = [];
		combinationsJS[k]["idCombination"] = parseInt(i);
		combinationsJS[k]["idsAttributes"] = combinations[i]["attributes"];
		combinationsJS[k]["quantity"] = combinations[i]["quantity"];
		combinationsJS[k]["price"] = combinations[i]["price"];
		combinationsJS[k]["wholesale_price"] =
			combinations[i]["wholesale_price"];
		combinationsJS[k]["ecotax"] = combinations[i]["ecotax"];
		combinationsJS[k]["image"] = parseInt(combinations[i]["id_image"]);
		combinationsJS[k]["reference"] = combinations[i]["reference"];
		combinationsJS[k]["reference_y2"] = combinations[i]["reference_y2"];
		combinationsJS[k]["unit_price"] = combinations[i]["unit_impact"];
		combinationsJS[k]["minimal_quantity"] = parseInt(
			combinations[i]["minimal_quantity"],
		);

		combinationsJS[k]["available_date"] = [];
		combinationsJS[k]["available_date"]["date"] =
			combinations[i]["available_date"];
		combinationsJS[k]["available_date"]["date_formatted"] =
			combinations[i]["date_formatted"];

		combinationsJS[k]["specific_price"] = [];
		combinationsJS[k]["specific_price"]["reduction_percent"] =
			combinations[i]["specific_price"] &&
			combinations[i]["specific_price"]["reduction"] &&
			combinations[i]["specific_price"]["reduction_type"] == "percentage"
				? combinations[i]["specific_price"]["reduction"] * 100
				: 0;
		combinationsJS[k]["specific_price"]["reduction_price"] =
			combinations[i]["specific_price"] &&
			combinations[i]["specific_price"]["reduction"] &&
			combinations[i]["specific_price"]["reduction_type"] == "amount"
				? combinations[i]["specific_price"]["reduction"]
				: 0;
		combinationsJS[k]["price"] =
			combinations[i]["specific_price"] &&
			combinations[i]["specific_price"]["price"] &&
			parseInt(combinations[i]["specific_price"]["price"]) != -1
				? combinations[i]["specific_price"]["price"]
				: combinations[i]["price"];

		combinationsJS[k]["reduction_type"] =
			combinations[i]["specific_price"] &&
			combinations[i]["specific_price"]["reduction_type"]
				? combinations[i]["specific_price"]["reduction_type"]
				: "";
		combinationsJS[k]["id_product_attribute"] =
			combinations[i]["specific_price"] &&
			combinations[i]["specific_price"]["id_product_attribute"]
				? combinations[i]["specific_price"]["id_product_attribute"]
				: 0;
		k++;
	}
	combinations = combinationsJS;
}
/* */

$(document).ready(function () {
	$('[data-toggle="tooltip"]').tooltip();

	// Rafraichissement de la liste des magasins
	$("#selectStoreModal").on("show.bs.modal", function (event) {
		let trigger = $(event.relatedTarget).data("trigger");
		fixStoreModal(trigger);
	});

	var url_found = checkUrl();
	//init the price in relation of the selected attributes
	if (!url_found) {
		if (
			typeof productHasAttributes != "undefined" &&
			productHasAttributes
		) {
			// findCombination();
		} else {
			if (quantityAvailable > 0) {
				$("#quantity_wanted").attr("max", quantityAvailable);
				checkMaximumQuantity();
			}
			refreshProductImages(0);
		}
	}

	initLocationChange();
	serialScrollSetNbImages();

	//init the serialScroll for thumbs
	if (!!$.prototype.serialScroll)
		$("#thumbs_list").serialScroll({
			items: "li:visible",
			prev: "#view_scroll_left",
			next: "#view_scroll_right",
			axis: "x",
			offset: 0,
			start: 0,
			stop: true,
			onBefore: serialScrollFixLock,
			duration: 700,
			step: 2,
			lazy: true,
			lock: false,
			force: false,
			cycle: false,
		});

	$("#thumbs_list").trigger("goto", 0);

	//set jqZoom parameters if needed
	if (typeof jqZoomEnabled != "undefined" && jqZoomEnabled) {
		if ($("#thumbs_list .shown img").length) {
			var new_src = $("#thumbs_list .shown img")
				.attr("src")
				.replace("cart_", "large_");
			if ($(".jqzoom img").attr("src") != new_src)
				$(".jqzoom img")
					.attr("src", new_src)
					.parent()
					.attr("href", new_src);
		}

		$(".jqzoom").jqzoom({
			zoomType: "innerzoom", //innerzoom/standard/reverse/drag
			zoomWidth: 458, //zooming div default width(default width value is 200)
			zoomHeight: 458, //zooming div default width(default height value is 200)
			xOffset: 21, //zooming div default offset(default offset value is 10)
			yOffset: 0,
			title: false,
		});
	}
	if (typeof contentOnly != "undefined" && !contentOnly) {
		if (!!$.prototype.fancybox)
			$("li:visible .fancybox, .fancybox.shown").fancybox({
				hideOnContentClick: true,
				openEffect: "elastic",
				closeEffect: "elastic",
			});
	} else if (typeof ajax_allowed != "undefined" && !ajax_allowed)
		$("#buy_block").attr("target", "_top");

	if (!!$.prototype.bxSlider)
		$("#bxslider").bxSlider({
			minSlides: 1,
			maxSlides: 6,
			slideWidth: 178,
			slideMargin: 20,
			pager: false,
			nextText: "",
			prevText: "",
			moveSlides: 1,
			infiniteLoop: false,
			hideControlOnEnd: true,
		});

	if (typeof $.uniform !== "undefined") {
		if (typeof product_fileDefaultHtml !== "undefined")
			$.uniform.defaults.fileDefaultHtml = product_fileDefaultHtml;
		if (typeof product_fileButtonHtml !== "undefined")
			$.uniform.defaults.fileButtonHtml = product_fileButtonHtml;
	}

	if ($("#customizationForm").length) {
		var url = window.location + "";
		if (url.indexOf("#") != -1) getProductAttribute();
	}

	/* HACK CYCLABLE */
	var add_to_wishlist = $("#wishlist_button").clone();
	if (typeof add_to_wishlist != "undefined" && add_to_wishlist) {
		add_to_wishlist.attr("id", "");
		add_to_wishlist.attr("class", "lienGris");
		add_to_wishlist.insertAfter($("#usefull_link_block"));
	}
	$("#AddToCartGris").click(function () {
		$("#test_to_cart button").click();
	});
});

$(window).resize(function () {
	serialScrollSetNbImages();
	$("#thumbs_list").trigger("goto", 0);
	serialScrollFixLock("", "", "", "", 0);
});

//hover 'other views' images management
$(document).on("mouseover", "#views_block li a", function () {
	displayImage($(this));
});
//add a link on the span 'view full size' and on the big image
$(document).on("click", "#view_full_size, #image-block", function (e) {
	$("#views_block .shown").click();
});

// Hide the customization submit button and display some message
$(document).on("click", "#customizedDatas input", function (e) {
	$("#customizedDatas input").hide();
	$("#ajax-loader").show();
	$("#customizedDatas").append(uploading_in_progress);
});

$(document).on("click", "a[name=resetImages]", function (e) {
	e.preventDefault();
	refreshProductImages(0);
});

$(document).on("click", ".color_pick", function (e) {
	e.preventDefault();
	colorPickerClick($(this));
	getProductAttribute();
});

$(document).on("change", ".attribute_select", function (e) {
	e.preventDefault();
	findCombination();
	getProductAttribute();
});

$(window).load(function (e) {
	e.preventDefault();

	if (typeof productHasAttributes != "undefined" && productHasAttributes) {
		findCombination();

		// Ne devrait normalement pas s'enclencher car la déclinaison par défaut pré-sélectionnée a tjr du stock
		if (!productIsBike && selectedCombination["qtyAccess"] <= 0) {
			console.warn("Aucun stock sur la déclinaison pré-sélectionnée");
			changeDefaultCombinationIfNotAvailable();
		}
	} else {
		// ANCHOR Pas de combinaison
		if (productIsBike) {
			setBikeStock();
		} else {
			setAccessoryStock();
		}
	}

	setTimeout(setCriteoScriptForProduct, 2000);
});

$(document).on("click", ".attribute_radio", function (e) {
	e.preventDefault();
	findCombination();
	getProductAttribute();
});

$(document).on("click", "button[name=saveCustomization]", function (e) {
	saveCustomization();
});

if (
	typeof ad !== "undefined" &&
	ad &&
	typeof adtoken !== "undefined" &&
	adtoken
) {
	$(document).on("click", "input[name=publish_button]", function (e) {
		e.preventDefault();
		submitPublishProduct(ad, 0, adtoken);
	});
	$(document).on("click", "input[name=lnk_view]", function (e) {
		e.preventDefault();
		submitPublishProduct(ad, 1, adtoken);
	});
}

if (typeof contentOnly != "undefined" && contentOnly) {
	$(document).on("click", ".fancybox", function (e) {
		e.preventDefault();
	});

	$(document).on("click", "#image-block", function (e) {
		e.preventDefault();
		var productUrl = window.document.location.href + "";
		var data = productUrl.replace(/[\?|&]content_only=1/, "");

		if (window.parent.page_name == "search")
			data +=
				(data.indexOf("?") < 0 ? "?" : "&") +
				"HTTP_REFERER=" +
				encodeURIComponent(window.parent.document.location.href);

		window.parent.document.location.href = data;
		return;
	});
}

// The button to increment the product value
$(document).on("click", ".product_quantity_up", function (e) {
	e.preventDefault();
	fieldName = $(this).data("field-qty");
	var currentVal = parseInt($("input[name=" + fieldName + "]").val());
	if (!allowBuyWhenOutOfStock && quantityAvailable > 0)
		quantityAvailableT = quantityAvailable;
	else quantityAvailableT = 100000000;
	if (!isNaN(currentVal) && currentVal < quantityAvailableT)
		$("input[name=" + fieldName + "]")
			.val(currentVal + 1)
			.trigger("keyup");
	else $("input[name=" + fieldName + "]").val(quantityAvailableT);
});
// The button to decrement the product value
$(document).on("click", ".product_quantity_down", function (e) {
	e.preventDefault();
	fieldName = $(this).data("field-qty");
	var currentVal = parseInt($("input[name=" + fieldName + "]").val());
	if (!isNaN(currentVal) && currentVal > 1)
		$("input[name=" + fieldName + "]")
			.val(currentVal - 1)
			.trigger("keyup");
	else $("input[name=" + fieldName + "]").val(1);
});

if (typeof minimalQuantity != "undefined" && minimalQuantity) {
	checkMinimalQuantity();
	$(document).on("keyup", "input[name=qty]", function (e) {
		checkMinimalQuantity(minimalQuantity);
	});
}

function fixStoreModal(trigger) {
	if (unsortedList && trigger == "menu") {
		$("#selectStoreModal .stores-list").find(".icon").hide();
		$(unsortedList).appendTo("#selectStoreModal .stores-list");
	} else {
		$("#selectStoreModal .stores-list").find(".icon").show();
		sortStockList();
	}
}

function sortStockList() {
	var sortedList = $("#selectStoreModal").find(".store-option");
	sortedList = sortedList.refresh();
	sortedList = $(sortedList).sort(sortStoresByStock);
	$(sortedList).appendTo("#selectStoreModal .stores-list");
	$("#selectStoreModal").addClass("stock-sorted");
}

function arrayUnique(a) {
	return a.reduce(function (p, c) {
		if (p.indexOf(c) < 0) p.push(c);
		return p;
	}, []);
}

//check if a function exists
function function_exists(function_name) {
	if (typeof function_name == "string")
		return typeof window[function_name] == "function";
	return function_name instanceof Function;
}

//execute oosHook js code
function oosHookJsCode() {
	for (var i = 0; i < oosHookJsCodeFunctions.length; i++) {
		if (function_exists(oosHookJsCodeFunctions[i]))
			setTimeout(oosHookJsCodeFunctions[i] + "()", 0);
	}
}

//add a combination of attributes in the global JS sytem
function addCombination(
	idCombination,
	arrayOfIdAttributes,
	quantity,
	price,
	ecotax,
	id_image,
	reference,
	unit_price,
	minimal_quantity,
	available_date,
	combination_specific_price,
) {
	globalQuantity += quantity;

	var combination = [];
	combination["idCombination"] = idCombination;
	combination["quantity"] = quantity;
	combination["idsAttributes"] = arrayOfIdAttributes;
	combination["price"] = price;
	combination["wholesale_price"] = wholesale_price;
	combination["ecotax"] = ecotax;
	combination["image"] = id_image;
	combination["reference"] = reference;
	combination["unit_price"] = unit_price;
	combination["minimal_quantity"] = minimal_quantity;
	combination["available_date"] = [];
	combination["available_date"] = available_date;
	combination["specific_price"] = [];
	combination["specific_price"] = combination_specific_price;
	combinations.push(combination);
}

// search the combinations' case of attributes and update displaying of availability, prices, ecotax, and image
function findCombination() {
	$("#minimal_quantity_wanted_p").hide();

	if (
		typeof $("#minimal_quantity_label").text() === "undefined" ||
		$("#minimal_quantity_label").html() > 1
	)
		$("#quantity_wanted").val(1);

	//create a temporary 'choice' array containing the choices of the customer
	var choice = [];
	var radio_inputs = parseInt(
		$("#attributes .checked > input[type=radio]").length,
	);
	if (radio_inputs) radio_inputs = "#attributes .checked > input[type=radio]";
	else radio_inputs = "#attributes input[type=radio]:checked";

	$(
		"#attributes select, #attributes input[type=hidden], " + radio_inputs,
	).each(function () {
		choice.push(parseInt($(this).val()));
	});

	if (typeof combinations == "undefined" || !combinations) combinations = [];

	//testing every combination to find the conbination's attributes' case of the user
	for (
		var combination = 0;
		combination < combinations.length;
		++combination
	) {
		//verify if this combinaison is the same that the user's choice
		var combinationMatchForm = true;

		$.each(
			combinations[combination]["idsAttributes"],
			function (key, value) {
				if (!in_array(parseInt(value), choice))
					combinationMatchForm = false;
			},
		);

		if (combinationMatchForm) {
			if (combinations[combination]["quantity"] > 0) {
				$("#quantity_wanted").attr(
					"max",
					combinations[combination]["quantity"],
				);
				checkMaximumQuantity();
			}

			if (combinations[combination]["minimal_quantity"] > 1) {
				$("#minimal_quantity_label").html(
					combinations[combination]["minimal_quantity"],
				);
				$("#minimal_quantity_wanted_p").show();
				$("#quantity_wanted").val(
					combinations[combination]["minimal_quantity"],
				);
				$("#quantity_wanted").bind("keyup", function () {
					checkMinimalQuantity(
						combinations[combination]["minimal_quantity"],
					);
				});
			}
			//combination of the user has been found in our specifications of combinations (created in back office)
			selectedCombination["unavailable"] = false;
			selectedCombination["reference"] =
				combinations[combination]["reference"];
			selectedCombination["reference_y2"] =
				combinations[combination]["reference_y2"];
			$("#idCombination").val(combinations[combination]["idCombination"]);

			if ($("#DiscoverAndTry").length) {
				var _href = $("#DiscoverAndTry")
					.attr("href")
					.replace(/&?id_combination=\d+/, "");
				$("#DiscoverAndTry").attr(
					"href",
					_href +
						"&id_combination=" +
						combinations[combination]["idCombination"],
				);
			}

			//get the data of product with these attributes
			quantityAvailable = combinations[combination]["quantity"];
			if (!productIsBike)
				selectedCombination["qtyAccess"] =
					combinations[combination]["quantity"];

			selectedCombination["price"] = combinations[combination]["price"];
			selectedCombination["wholesale_price"] =
				combinations[combination]["wholesale_price"];
			selectedCombination["unit_price"] =
				combinations[combination]["unit_price"];
			selectedCombination["specific_price"] =
				combinations[combination]["specific_price"];
			if (combinations[combination]["ecotax"])
				selectedCombination["ecotax"] =
					combinations[combination]["ecotax"];
			else selectedCombination["ecotax"] = default_eco_tax;

			//show the large image in relation to the selected combination
			if (
				combinations[combination]["image"] &&
				combinations[combination]["image"] != -1
			)
				displayImage(
					$("#thumb_" + combinations[combination]["image"]).parent(),
				);

			//show discounts values according to the selected combination
			if (
				combinations[combination]["idCombination"] &&
				combinations[combination]["idCombination"] > 0
			)
				displayDiscounts(combinations[combination]["idCombination"]);

			//get available_date for combination product
			selectedCombination["available_date"] =
				combinations[combination]["available_date"];

			//update the display
			updateDisplay();

			if (firstTime) {
				refreshProductImages(0);
				firstTime = false;
			} else {
				refreshProductImages(
					combinations[combination]["idCombination"],
				);
			}
			//leave the function because combination has been found

			return;
		}
	}

	// this combination doesn't exist (not created in back office)
	selectedCombination["unavailable"] = true;
	if (typeof selectedCombination["available_date"] != "undefined")
		delete selectedCombination["available_date"];

	updateDisplay();
}

function sortStoresByStock(a, b) {
	a = $(a).attr("data-status-stock");
	b = $(b).attr("data-status-stock");
	return b - a;
}

function sortStoresByName(a, b) {
	let firstLetterA = $(a).find(".store-name-value").text().trim()[0];
	let firstLetterB = $(b).find(".store-name-value").text().trim()[0];
	return firstLetterA > firstLetterB ? 1 : -1;
}

function setBikeStock() {
	// ANCHOR Affichage en fonction du stock par magasin et déclinaison
	let product_id = $("#product_page_product_id").val();
	let combination_id = $("#idCombination").val();

	// Ici, tout dépend de si on a un magasin sélectionné ou non

	let is_bike_available = selectedCombination["available"];
	if (typeof is_bike_available === "undefined")
		is_bike_available = !selectedCombination["unavailable"];

	let itemToShow; // Affichage de stock qui sera à afficher

	if (!productAvailableForOrder) {
		// NOTE 00 - 01
		itemToShow = $(".stock-container.product-disabled");
		displayStockView(itemToShow);
	} else if (!is_bike_available) {
		itemToShow = $(".stock-container.combination-unavailable");
		displayStockView(itemToShow);
	} else {
		$.ajax({
			type: "GET",
			url: getStoreStockUrl,
			cache: false,
			async: true,
			data: {
				action: "getGlobalStock",
				ajax: true,
				id_product: product_id,
				id_combination: combination_id,
			},
			success: function (data) {
				if (data) {
					try {
						data = $.parseJSON(data);
						if (data.error) {
							console.warn(data.message);
						} else {
							// ANCHOR Cas spécifique de l'affichage "commander" à la place de "contacter" pour le produit 17901
							let openTooltipAuto = false;

							if (
								data.availableStores &&
								data.availableStores.length == 0 &&
								product_id == 17901
							) {
								itemToShow = $(
									".stock-container.product-to-order-in-store",
								);

								// On indique l'état de stock pour chaque magasin dans le modal de sélection
								$("#selectStoreModal .store-option").each(
									function (key, value) {
										let store_option = $(this);
										if (
											!$(store_option).hasClass(
												"disabled",
											)
										) {
											$(this).removeClass(
												"store-has-stock web-has-stock store-retrait-stock store-test-stock out-of-stock",
											);
											$(this).find(".icon").remove();
											$(this)
												.find(".icon")
												.attr("data-toggle", "tooltip")
												.attr(
													"data-placement",
													"right",
												);
										} else {
											$(this).attr(
												"data-status-stock",
												-1,
											);
										}
									},
								);
							} else if (
								data.availableStores ||
								data.retraitStores ||
								data.stockTestStores ||
								data.stockReferenceStores ||
								data.availableStoresAndNoCC
							) {
								if (selectedStore) {
									if (
										data.availableStores.includes(
											selectedStore.id_entrepot,
										)
									) {
										// NOTE B4 - B5
										itemToShow = $(
											".stock-container.product-available",
										);
									} else if (
										data.stockReferenceStores &&
										data.stockReferenceStores.includes(
											selectedStore.id_entrepot,
										)
									) {
										openTooltipAuto = true;
										itemToShow = $(
											".stock-container.product-available-test",
										);
									} else if (
										data.stockTestStores &&
										data.stockTestStores.includes(
											selectedStore.id_entrepot,
										)
									) {
										openTooltipAuto = true;
										itemToShow = $(
											".stock-container.product-available-test",
										);
									} else if (
										data.retraitStores &&
										data.retraitStores.includes(
											selectedStore.id_entrepot,
										)
									) {
										itemToShow = $(
											".stock-container.product-available-in-sibling-warehouse",
										);
									} else {
										if (
											data.noCCStores.availableStores
												.length > 0 ||
											data.noCCStores.retraitStores
												.length > 0 ||
											data.noCCStores.stockTestStores
												.length > 0
										) {
											let btnDisabled = $(
												".stock-container.product-no-stock .btn.btn-rouge",
											).clone();
											if (
												data.noCCStores
													.availableStores &&
												data.noCCStores.availableStores.includes(
													selectedStore.id_entrepot,
												)
											) {
												$(
													".stock-container.product-available #add_to_cart",
												).replaceWith(btnDisabled);

												itemToShow = $(
													".stock-container.product-available",
												);
											} else if (
												data.noCCStores.retraitStores &&
												data.noCCStores.retraitStores.includes(
													selectedStore.id_entrepot,
												)
											) {
												$(
													".stock-container.product-available-in-sibling-warehouse #add_to_cart",
												).replaceWith(btnDisabled);
												itemToShow = $(
													".stock-container.product-available-in-sibling-warehouse",
												);
											} else {
												itemToShow = $(
													".stock-container.product-no-stock",
												);
											}
										} else {
											itemToShow = $(
												".stock-container.product-no-stock",
											);
										}
									}
								} else {
									if (
										data.availableStores.length >= 1 ||
										data.retraitStores.length >= 1
									) {
										// Compte uniquement les valeurs uniques
										let uniqueStores = new Set([
											...data.availableStores,
											...data.retraitStores,
											...data.stockTestStores,
											...data.stockReferenceStores,
										]);

										const uniqueCount = uniqueStores.size;

										itemToShow = $(
											".stock-container.product-available",
										);
										$(
											".stock-indicator-container .nb-stores-in-stock",
										).text(uniqueCount);

										if (
											data.availableStores.length +
												data.retraitStores.length +
												data.stockTestStores.length +
												data.stockReferenceStores
													.length ==
											1
										) {
											$(
												".stock-indicator-container .stores-global-indicator",
											).text("magasin");
										} else {
											$(
												".stock-indicator-container .stores-global-indicator",
											).text("magasins");
										}
									} else if (
										data.stockReferenceStores.length >= 1 ||
										data.stockTestStores.length >= 1
									) {
										itemToShow = $(
											".stock-container.product-stock-test",
										);
										$(
											".stock-indicator-container .nb-stores-in-test",
										).text(
											data.stockReferenceStores.length +
												data.stockTestStores.length,
										);

										if (
											data.stockReferenceStores.length +
												data.stockTestStores.length ==
											1
										) {
											$(
												".stock-indicator-container .stores-test-indicator",
											).text("magasin");
										} else {
											$(
												".stock-indicator-container .stores-test-indicator",
											).text("magasins");
										}
									} else {
										if (
											data.stockReferenceStores &&
											data.stockReferenceStores.includes(
												selectedStore.id_entrepot,
											)
										) {
											itemToShow = $(
												".stock-container.product-available",
											);
										} else {
											itemToShow = $(
												".stock-container.product-no-stock",
											);
										}
									}
								}

								// On indique l'état de stock pour chaque magasin dans le modal de sélection
								$("#selectStoreModal .store-option").each(
									function (key, value) {
										let store_option = $(this);
										if (
											!$(store_option).hasClass(
												"disabled",
											)
										) {
											let store_option_input =
												$(store_option).find("input");
											let store_option_value =
												$(store_option_input).val();
											$(this).removeClass(
												"store-has-stock web-has-stock store-retrait-stock store-test-stock out-of-stock",
											);
											$(this).find(".icon").remove();

											if (
												productAvailableForOrder &&
												is_bike_available
											) {
												if (
													data.availableStores.includes(
														store_option_value,
													)
												) {
													$(this).addClass(
														"store-has-stock",
													);
													$(this).attr(
														"data-status-stock",
														4,
													);
													$(this).prepend(
														'<span class="icon icon-1x material-icons-filled">check_circle</span>',
													);
													$(this)
														.find(".icon")
														.attr(
															"title",
															"Disponible en magasin",
														);
												} else if (
													data.stockReferenceStores &&
													data.stockReferenceStores.includes(
														store_option_value,
													)
												) {
													$(this).addClass(
														"store-test-stock",
													);
													$(this).attr(
														"data-status-stock",
														3,
													);
													$(this).prepend(
														'<span class="icon icon-1x material-icons-outlined">check_circle</span>',
													);
													$(this)
														.find(".icon")
														.attr(
															"title",
															"Visible en magasin",
														);
												} else if (
													data.stockTestStores &&
													data.stockTestStores.includes(
														store_option_value,
													)
												) {
													$(this).addClass(
														"store-test-stock",
													);
													$(this).attr(
														"data-status-stock",
														3,
													);
													$(this).prepend(
														'<span class="icon icon-1x material-icons-outlined">check_circle</span>',
													);
													$(this)
														.find(".icon")
														.attr(
															"title",
															"Visible en magasin",
														);
												} else if (
													data.retraitStores.includes(
														store_option_value,
													)
												) {
													$(this).addClass(
														"store-has-stock",
													);
													$(this).attr(
														"data-status-stock",
														2,
													);
													$(this).prepend(
														'<svg class="icon icon-stock-retrait"><path d="M18.3,4.5c0-0.3-0.2-0.7-0.5-0.8c-1.2-0.5-2.4-1-3.5-1.6C14,2,13.8,1.9,13.5,1.8c0,0,0,0,0,0c-1.1-0.5-2.3-1-3.4-1.5 C9.6,0,9.2-0.1,8.6,0.1C8.2,0.3,7.9,0.4,7.5,0.6c-2.3,1-4.6,2.1-7,3.1h0c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0.1c0,0,0,0-0.1,0.1 c0,0-0.1,0.1-0.1,0.2C0.1,4.2,0,4.4,0,4.6v10.1c0,0.3,0.2,0.7,0.5,0.9l8.2,3.6c0.1,0.1,0.3,0.1,0.4,0.1c0,0,0.1,0,0.1,0s0.1,0,0.1,0 c0.1,0,0.3,0,0.4-0.1c2.7-1.2,5.4-2.4,8.2-3.6c0.3-0.1,0.5-0.5,0.5-0.9L18.3,4.5C18.3,4.6,18.3,4.6,18.3,4.5L18.3,4.5z M7,8.4 C7.4,8.6,7.8,8.8,8.2,9v7.8C6.1,15.8,4,14.9,2,14V6.1C3.7,6.9,5.3,7.6,7,8.4z M10.2,8.9c0.8-0.4,1.6-0.8,2.4-1.1c0.5-0.2,0.9-0.4,1.3-0.6c0.8-0.4,1.6-0.7,2.4-1.1V14c-2,0.9-4.1,1.8-6.2,2.7V8.9z M14.9,4.6c-0.7,0.3-1.3,0.6-2,0.9 C11.7,6,10.4,6.6,9.2,7.2C8.6,6.9,8.1,6.7,7.6,6.5c1.8-0.9,3.6-1.8,5.5-2.7C13.6,4,14.3,4.3,14.9,4.6L14.9,4.6z M9.2,2 c0.5,0.2,1,0.4,1.5,0.7C8.8,3.6,7,4.5,5.2,5.4L3.4,4.6C3.4,4.6,9.2,2,9.2,2z"/></svg>',
													);
													$(this)
														.find(".icon")
														.attr(
															"title",
															"Disponible en retrait sous 5j",
														);
												} else {
													$(this).addClass(
														"out-of-stock",
													);
													$(this).attr(
														"data-status-stock",
														1,
													);
													$(this).prepend(
														'<span class="icon icon-1x material-icons-outlined">info</span>',
													);
													$(this)
														.find(".icon")
														.attr(
															"title",
															"Contactez le magasin pour connaître sa disponibilité",
														);
												}
											} else if (
												data.availableStores.length > 0
											) {
												$(this).addClass(
													"out-of-stock",
												);
												$(this).attr(
													"data-status-stock",
													1,
												);
												$(this).prepend(
													'<span class="icon icon-1x material-icons-outlined">info</span>',
												);
												$(this)
													.find(".icon")
													.attr(
														"title",
														"Contactez le magasin pour connaître sa disponibilité",
													);
											}

											$(this)
												.find(".icon")
												.attr("data-toggle", "tooltip")
												.attr(
													"data-placement",
													"right",
												);
										} else {
											$(this).attr(
												"data-status-stock",
												-1,
											);
										}
									},
								);
							}

							if (openTooltipAuto) {
								// Si vélo stock test, alors on affiche la tooltip à rallonge
								setTimeout(function () {
									$(
										".product-available-test .stores-with-stock",
									).tooltip("show");

									// Create an intersection observer with the callback function and options
									const observer = new IntersectionObserver(
										handleIntersectionTooltipVeloTest,
										observerOptions,
									);

									// Check if the element is initially visible and trigger the observer
									const targetElement = $(
										".product-available-test .stores-with-stock",
									)[0];
									if (
										targetElement &&
										targetElement.getBoundingClientRect()
											.top < window.innerHeight
									) {
										handleIntersectionTooltipVeloTest(
											[{ isIntersecting: true }],
											observer,
										);
									} else {
										// If not initially visible, start observing when the user scrolls
										window.addEventListener("scroll", () =>
											observer.observe(targetElement),
										);
									}
								}, 1000);
							}
						}

						displayStockView(itemToShow);
					} catch (e) {
						console.warn(e);
					}
				}
			},
			error: function (XMLHttpRequest, textStatus, errorThrown) {
				console.warn(XMLHttpRequest, textStatus, errorThrown);
			},
		});
	}

	getCombinationSelected();
	sortStockList();
}

function displayStockView(itemToShow) {
	// On active les nouveaux tooltip
	$('[data-toggle="tooltip"]').tooltip();

	// On masque le placeholder
	$(".stock-container.content-placeholder").hide();

	// On affiche l'état de stock
	$(".stock-container").hide();
	$(itemToShow).show();
}

function getCombinationSelected() {
	let selectedCombinationText = "";
	$(".attribute_fieldset").each(function () {
		selectedCombinationText += $(this).find(".field-label").text();
		selectedCombinationText += " ";
		selectedCombinationText += $(this)
			.find(".attribute_select")
			.find(":selected")
			.text()
			.trim();
		if ($(this).index() != $(this).siblings().length)
			selectedCombinationText += ", ";
	});
	$(".product-attributes-text").text("(" + selectedCombinationText + ")");
}

function setAccessoryStock() {
	// On remasque toutes les indications de stock possibles
	$(".stock-container").hide();

	if (
		!selectedCombination["unavailable"] &&
		quantityAvailable > 0 &&
		productAvailableForOrder == 1
	) {
		$(".in-stock").show();
		$(".out-of-stock").hide();
		$(".not-in-stock").hide();
		$("#dispnoDate").hide();
		$("#dispo-status").show();

		//show the choice of quantities
		$("#quantity_wanted_p:hidden").show();

		//show the "add to cart" button ONLY if it was hidden
		$("#AddToCard:hidden").show();

		//hide the hook out of stock
		$("#oosHook").hide();

		$("#availability_date").hide();

		//availability value management
		if (stock_management && availableNowValue != "") {
			$("#availability_value")
				.removeClass("warning_inline")
				.text(availableNowValue)
				.show();
			$("#availability_statut:hidden").show();
		} else $("#availability_statut:visible").hide();

		//'last quantities' message management
		if (!allowBuyWhenOutOfStock) {
			if (
				quantityAvailable <=
				maxQuantityToAllowDisplayOfLastQuantityMessage
			)
				$("#last_quantities").show();
			else $("#last_quantities").hide();
		}

		if (quantitiesDisplayAllowed) {
			$("#pQuantityAvailable:hidden").show();
			$("#quantityAvailable").text(quantityAvailable);

			if (quantityAvailable < 2) {
				// we have 1 or less product in stock and need to show "item" instead of "items"
				$("#quantityAvailableTxt").show();
				$("#quantityAvailableTxtMultiple").hide();
			} else {
				$("#quantityAvailableTxt").hide();
				$("#quantityAvailableTxtMultiple").show();
			}
		}
	} else {
		$(".in-stock").hide();
		$(".out-of-stock").show();
		$("#quantity_wanted_p").hide();

		//show the hook out of stock
		if (productAvailableForOrder == 1) {
			$("#oosHook").show();
			$("#quantity_wanted_p").hide();
			if ($("#oosHook").length > 0 && function_exists("oosHookJsCode"))
				oosHookJsCode();
		}

		//hide 'last quantities' message if it was previously visible
		$("#last_quantities:visible").hide();

		//hide the quantity of pieces if it was previously visible
		$("#pQuantityAvailable:visible").hide();

		//hide the choice of quantities
		if (!allowBuyWhenOutOfStock) {
			$("#quantity_wanted_p").hide();
		}

		//display that the product is unavailable with theses attributes
		if (!selectedCombination["unavailable"]) {
			$("#availability_value").text(
				doesntExistNoMore +
					(globalQuantity > 0 ? " " + doesntExistNoMoreBut : ""),
			);
			$(".not-in-stock").hide();
			if (!allowBuyWhenOutOfStock)
				$("#availability_value").addClass("warning_inline");
		} else {
			$("#availability_value")
				.text(doesntExist)
				.addClass("warning_inline");
			// ANCHOR Produit n'existe pas du tout
			$("#oosHook").hide();
			$(".stock-indicator.out-of-stock").hide();
			$(".in-stock").hide();
			$("#oos_modal_btn").show();
			$("#oos_modal_btn").addClass("almosthide");
			$(".not-in-stock").show();
		}

		if (
			(stock_management == 1 && !allowBuyWhenOutOfStock) ||
			(!stock_management && selectedCombination["unavailable"])
		)
			$("#availability_statut:hidden").show();

		if (
			typeof selectedCombination["available_date"] != "undefined" &&
			selectedCombination["available_date"]["date"].length != 0
		) {
			var available_date = selectedCombination["available_date"]["date"];
			var tab_date = available_date.split("-");
			var time_available = new Date(
				tab_date[0],
				tab_date[1],
				tab_date[2],
			);
			time_available.setMonth(time_available.getMonth() - 1);
			var now = new Date();
			if (
				now.getTime() < time_available.getTime() &&
				$("#availability_date_value").text() !=
					selectedCombination["available_date"]["date_formatted"]
			) {
				$("#dispnoDate").fadeOut("normal", function () {
					$("#availability_date_value").text(
						selectedCombination["available_date"]["date_formatted"],
					);
					$(this).show();
					$("#dispo-status").hide();
				});
			} else if (now.getTime() < time_available.getTime()) {
				$("#dispnoDate").show();
				$("#dispo-status").hide();
			}
		} else {
			$("#dispnoDate").hide();
			$("#dispo-status").show();
		}

		//show the 'add to cart' button ONLY IF it's possible to buy when out of stock AND if it was previously invisible
		if (
			allowBuyWhenOutOfStock &&
			!selectedCombination["unavailable"] &&
			productAvailableForOrder
		) {
			$("#AddToCard:hidden").show();
			$("#quantity_wanted_p").show();

			if (stock_management && availableLaterValue != "")
				$("#availability_value")
					.removeClass("warning_inline")
					.text(availableLaterValue)
					.show();
			else $("#availability_statut:visible").hide();
		} else {
			if (!selectedCombination["unavailable"])
				$("#AddToCard:visible").hide();
			//$('#quantity_wanted_p').removeClass('almosthide');
			if (stock_management == 1 && productAvailableForOrder)
				$("#availability_statut:hidden").show();
		}

		if (productAvailableForOrder == 0)
			$("#availability_statut:visible").hide();
	}

	$(".stock-container").show();
	$(".stock-container.content-placeholder").hide();
}

//update display of the availability of the product AND the prices of the product
function updateDisplay() {
	var productPriceDisplay = productPrice;
	var productPriceWithoutReductionDisplay = productPriceWithoutReduction;

	// ANCHOR Mise à jour du statut de stock du produit !
	if (productIsBike) {
		setBikeStock();
	} else {
		setAccessoryStock();
	}

	// ANCHOR Mise à jour de la référence produit
	if (selectedCombination["reference"] || productReference) {
		if (selectedCombination["reference"])
			$("#product_reference span").text(selectedCombination["reference"]);
		else if (productReference)
			$("#product_reference span").text(productReference);
		$("#product_reference:hidden").show();
	} else $("#product_reference:visible").hide();

	// ANCHOR Mise à jour de la référence Y2
	if (selectedCombination["reference_y2"]) {
		if (selectedCombination["reference_y2"])
			$("#product_reference_y2 span").text(
				selectedCombination["reference_y2"],
			);
		$("#product_reference_y2:hidden").show();
	} else $("#product_reference_y2:visible").hide();

	// ANCHOR Mise à jour du prix
	// If we have combinations, update price section: amounts, currency, discount amounts,...
	if (productHasAttributes) {
		updatePrice();
	}

	// ANCHOR On affiche l'état du stock si le produit est disponible
	if (!selectedCombination["unavailable"])
		$(".blockcart").removeClass("almosthide");
	else {
		$("#dispo-status").hide();
	}
}

function updatePrice() {
	// Get combination prices
	var combID = $("#idCombination").val();
	var combination = combinationsFromController[combID];
	if (typeof combination == "undefined") return;

	// Set product (not the combination) base price
	var basePriceWithoutTax = productBasePriceTaxExcl;
	var priceWithGroupReductionWithoutTax = 0;

	// Apply combination price impact
	// 0 by default, +x if price is inscreased, -x if price is decreased
	basePriceWithoutTax = basePriceWithoutTax + +combination.price;

	// If a specific price redefine the combination base price
	if (combination.specific_price && combination.specific_price.price > 0) {
		if (combination.specific_price.id_product_attribute === 0)
			basePriceWithoutTax = +combination.specific_price.price;
		else
			basePriceWithoutTax =
				+combination.specific_price.price + +combination.price;
	}

	// Apply group reduction
	priceWithGroupReductionWithoutTax =
		basePriceWithoutTax * (1 - group_reduction);
	var priceWithDiscountsWithoutTax = priceWithGroupReductionWithoutTax;

	// Apply specific price (discount)
	// We only apply percentage discount and discount amount given before tax
	// Specific price give after tax will be handled after taxes are added
	if (
		combination.specific_price &&
		combination.specific_price.reduction > 0
	) {
		if (combination.specific_price.reduction_type == "amount") {
			if (
				typeof combination.specific_price.reduction_tax !==
					"undefined" &&
				combination.specific_price.reduction_tax === "0"
			) {
				var reduction =
					+combination.specific_price.reduction / currencyRate;
				priceWithDiscountsWithoutTax -= reduction;
			}
		} else if (combination.specific_price.reduction_type == "percentage") {
			priceWithDiscountsWithoutTax =
				priceWithDiscountsWithoutTax *
				(1 - +combination.specific_price.reduction);
		}
	}

	// Apply Tax if necessary
	if (noTaxForThisProduct || customerGroupWithoutTax) {
		basePriceDisplay = basePriceWithoutTax;
		priceWithDiscountsDisplay = priceWithDiscountsWithoutTax;
	} else {
		basePriceDisplay = basePriceWithoutTax * (taxRate / 100 + 1);
		priceWithDiscountsDisplay =
			priceWithDiscountsWithoutTax * (taxRate / 100 + 1);
	}

	if (default_eco_tax) {
		// combination.ecotax doesn't modify the price but only the display
		basePriceDisplay =
			basePriceDisplay + default_eco_tax * (1 + ecotaxTax_rate / 100);
		priceWithDiscountsDisplay =
			priceWithDiscountsDisplay +
			default_eco_tax * (1 + ecotaxTax_rate / 100);
	}

	// If the specific price was given after tax, we apply it now
	if (
		combination.specific_price &&
		combination.specific_price.reduction > 0
	) {
		if (combination.specific_price.reduction_type == "amount") {
			if (
				typeof combination.specific_price.reduction_tax ===
					"undefined" ||
				(typeof combination.specific_price.reduction_tax !==
					"undefined" &&
					combination.specific_price.reduction_tax === "1")
			) {
				var reduction =
					+combination.specific_price.reduction / currencyRate;
				priceWithDiscountsDisplay -= reduction;
				// We recalculate the price without tax in order to keep the data consistency
				priceWithDiscountsWithoutTax =
					priceWithDiscountsDisplay -
					reduction * (1 / (1 + taxRate / 100));
			}
		}
	}

	// Compute discount value and percentage
	// Done just before display update so we have final prices
	if (basePriceDisplay != priceWithDiscountsDisplay) {
		var discountValue = basePriceDisplay - priceWithDiscountsDisplay;
		var discountPercentage =
			(1 - priceWithDiscountsDisplay / basePriceDisplay) * 100;
	}

	var unit_impact = +combination.unit_impact;
	if (productUnitPriceRatio > 0 || unit_impact) {
		if (unit_impact) {
			baseUnitPrice = productBasePriceTaxExcl / productUnitPriceRatio;
			unit_price = baseUnitPrice + unit_impact;

			if (!noTaxForThisProduct || !customerGroupWithoutTax)
				unit_price = unit_price * (taxRate / 100 + 1);
		} else unit_price = priceWithDiscountsDisplay / productUnitPriceRatio;
	}

	/*  Update the page content, no price calculation happens after */

	// $('.product-wholesaleprice').hide();
	if (combination.wholesale_price > 0) {
		$(".prixProduit .product-wholesaleprice .prixx").html(
			formatCurrency(
				combination.wholesale_price,
				currencyFormat,
				currencySign,
				currencyBlank,
			) + " HT",
		);
		// $('.product-wholesaleprice').show();
	}

	// Hide everything then show what needs to be shown
	$("#reduction_amount").hide();
	$(
		"#old_price,#old_price_display,#old_price_display_taxes,.price-percent-reduction",
	).hide();
	$(".price-ecotax").hide();
	$(".unit-price").hide();

	// HACK: cyclable
	var kalkhoff200 = [];
	if ($.inArray(id_product, kalkhoff200) != -1) {
		$("#our_price_display")
			.text(
				formatCurrency(
					(priceWithDiscountsDisplay - 200) * currencyRate,
					currencyFormat,
					currencySign,
					currencyBlank,
				),
			)
			.trigger("change");
		$(".old-price")
			.text(
				formatCurrency(
					priceWithDiscountsDisplay * currencyRate,
					currencyFormat,
					currencySign,
					currencyBlank,
				),
			)
			.trigger("change");
	} else {
		$("#our_price_display")
			.text(
				formatCurrency(
					priceWithDiscountsDisplay * currencyRate,
					currencyFormat,
					currencySign,
					currencyBlank,
				).replace(/\,00/g, ""),
			)
			.trigger("change");
	}

	// If the calculated price (after all discounts) is different than the base price
	// we show the old price striked through
	if (priceWithDiscountsDisplay.toFixed(2) != basePriceDisplay.toFixed(2)) {
		$("#old_price_display").text(
			formatCurrency(
				basePriceDisplay * currencyRate,
				currencyFormat,
				currencySign,
				currencyBlank,
			).replace(/\,00/g, ""),
		);
		$(
			"#old_price,#old_price_display,#old_price_display_taxes,.price-percent-reduction",
		).show();
		if ($(".price-percent-reduction .value-reduction") && discountValue) {
			$(".price-percent-reduction .value-reduction").text(
				formatCurrency(
					+discountValue * currencyRate,
					currencyFormat,
					currencySign,
					currencyBlank,
				).replace(",00", ""),
			);
		}

		// Then if it's not only a group reduction we display the discount in red box
		if (priceWithDiscountsWithoutTax != priceWithGroupReductionWithoutTax) {
			if (combination.specific_price.reduction_type == "amount") {
				$("#reduction_amount_display").html(
					"-" +
						formatCurrency(
							+discountValue * currencyRate,
							currencyFormat,
							currencySign,
							currencyBlank,
						),
				);
				$("#reduction_amount").show();
			} else {
				$("#reduction_percent_display").html(
					"-" + parseFloat(discountPercentage).toFixed(0) + "%",
				);
				$("#reduction_percent").show();
			}
		}

		$("#our_price_display").removeClass("black");
	} else {
		$("#our_price_display").addClass("black");
	}

	// Green Tax (Eco tax)
	// Update display of Green Tax
	if (default_eco_tax) {
		ecotax = default_eco_tax;

		// If the default product ecotax is overridden by the combination
		if (combination.ecotax) ecotax = +combination.ecotax;

		if (!noTaxForThisProduct) ecotax = ecotax * (1 + ecotaxTax_rate / 100);

		$("#ecotax_price_display").text(
			formatCurrency(
				ecotax * currencyRate,
				currencyFormat,
				currencySign,
				currencyBlank,
			),
		);
		$(".price-ecotax").show();
	}

	// Unit price are the price per piece, per Kg, per m²
	// It doesn't modify the price, it's only for display
	if (productUnitPriceRatio > 0) {
		$("#unit_price_display").text(
			formatCurrency(
				unit_price * currencyRate,
				currencyFormat,
				currencySign,
				currencyBlank,
			),
		);
		$(".unit-price").show();
	}

	// If there is a quantity discount table,
	// we update it according to the new price
	updateDiscountTable(priceWithDiscountsDisplay);
}

// ANCHOR Vérification quantité max
$("input#quantity_wanted").on("change paste keyup input", function () {
	checkMaximumQuantity(parseInt($("#quantity_wanted").attr("value")));
});

$("#quantity_wanted_p button.quantity-plus").on("click", function () {
	let newValue = parseInt($("#quantity_wanted").attr("value")) + 1;
	if (checkMaximumQuantity(newValue)) {
		$("#quantity_wanted").attr("value", newValue);
	} else {
		console.warn("Pas assez de quantités disponibles");
	}
});

$("#quantity_wanted_p button.quantity-minus").on("click", function () {
	let newValue = parseInt($("#quantity_wanted").attr("value")) - 1;
	if (newValue != 0 && checkMaximumQuantity(newValue)) {
		$("#quantity_wanted").attr("value", newValue);
	}
});

function checkMaximumQuantity(askedValue) {
	if (!askedValue) askedValue = parseInt($("#quantity_wanted").attr("value"));
	let max_value = $("#quantity_wanted").attr("max");

	if (askedValue > max_value) {
		$("#quantity_wanted").attr("value", max_value);
		$("#quantity_wanted_p button.quantity-plus").attr(
			"disabled",
			"disabled",
		);
		return false;
	} else if (askedValue == max_value) {
		$("#quantity_wanted_p button.quantity-plus").attr(
			"disabled",
			"disabled",
		);
		return true;
	} else if (askedValue < max_value) {
		$("#quantity_wanted_p button.quantity-plus").removeAttr("disabled");
		return true;
	}
}

//update display of the large image
function displayImage(domAAroundImgThumb, no_animation) {
	if (typeof no_animation == "undefined") no_animation = false;
	if (domAAroundImgThumb.attr("href")) {
		var new_src = domAAroundImgThumb
			.attr("href")
			.replace("thickbox", "large");
		var new_title = domAAroundImgThumb.attr("title");
		var new_href = domAAroundImgThumb.attr("href");
		if ($("#bigpic").attr("src") != new_src) {
			$("#bigpic")
				.attr({
					src: new_src,
					alt: new_title,
					title: new_title,
				})
				.load(function () {
					if (typeof jqZoomEnabled != "undefined" && jqZoomEnabled)
						$(this).attr("rel", new_href);
				});
		}
		$("#views_block li a").removeClass("shown");
		$(domAAroundImgThumb).addClass("shown");
	}
}

//update display of the discounts table
function displayDiscounts(combination) {
	$("#quantityDiscount tbody tr").each(function () {
		if (
			$(this).attr("id") != "quantityDiscount_0" &&
			$(this).attr("id") != "quantityDiscount_" + combination &&
			$(this).attr("id") != "noQuantityDiscount"
		)
			$(this).hide();
	});

	if (
		$(
			"#quantityDiscount_" +
				combination +
				",.quantityDiscount_" +
				combination,
		).length != 0 ||
		$("#quantityDiscount_0,.quantityDiscount_0").length != 0
	) {
		$("#quantityDiscount").parent().show();
		$(
			"#quantityDiscount_" +
				combination +
				",.quantityDiscount_" +
				combination,
		).show();
		$("#noQuantityDiscount").hide();
	} else {
		$("#quantityDiscount").parent().hide();
		$("#noQuantityDiscount").show();
	}
}

function updateDiscountTable(newPrice) {
	$("#quantityDiscount tbody tr").each(function () {
		var type = $(this).data("discount-type");
		var discount = $(this).data("discount");
		var quantity = $(this).data("discount-quantity");

		if (type == "percentage") {
			var discountedPrice = newPrice * (1 - discount / 100);
			var discountUpTo = newPrice * (discount / 100) * quantity;
		} else if (type == "amount") {
			var discountedPrice = newPrice - discount;
			var discountUpTo = discount * quantity;
		}

		if (displayDiscountPrice != 0)
			$(this)
				.children("td")
				.eq(1)
				.text(
					formatCurrency(
						discountedPrice * currencyRate,
						currencyFormat,
						currencySign,
						currencyBlank,
					),
				);
		$(this)
			.children("td")
			.eq(2)
			.text(
				upToTxt +
					" " +
					formatCurrency(
						discountUpTo * currencyRate,
						currencyFormat,
						currencySign,
						currencyBlank,
					),
			);
	});
}

function serialScrollFixLock(event, targeted, scrolled, items, position) {
	var serialScrollNbImages = $("#thumbs_list li:visible").length;
	var leftArrow = position == 0 ? true : false;
	var rightArrow =
		position + serialScrollNbImagesDisplayed >= serialScrollNbImages
			? true
			: false;

	$("#view_scroll_left")
		.css("cursor", leftArrow ? "default" : "pointer")
		.css("display", leftArrow ? "none" : "block")
		.fadeTo(0, leftArrow ? 0 : 1);
	$("#view_scroll_right")
		.css("cursor", rightArrow ? "default" : "pointer")
		.fadeTo(0, rightArrow ? 0 : 1)
		.css("display", rightArrow ? "none" : "block");
	return true;
}

function serialScrollSetNbImages() {
	serialScrollNbImagesDisplayed = 4;
	if ($("#thumbs_list").outerWidth(true) < 294)
		serialScrollNbImagesDisplayed = 2;
	else if ($("#thumbs_list").outerWidth(true) < 392)
		serialScrollNbImagesDisplayed = 3;
}

// Change the current product images regarding the combination selected
function refreshProductImages(id_product_attribute) {
	id_product_attribute = parseInt(id_product_attribute);

	if (
		id_product_attribute > 0 &&
		typeof combinationImages != "undefined" &&
		typeof combinationImages[id_product_attribute] != "undefined"
	) {
		//$('#thumbs_list li').hide();
		for (var i = 0; i < combinationImages[id_product_attribute].length; i++)
			if (typeof jqZoomEnabled != "undefined" && jqZoomEnabled)
				$(
					"#thumbnail_" +
						parseInt(combinationImages[id_product_attribute][i]),
				)
					.show()
					.children("a.shown")
					.trigger("click");
			else
				$(
					"#thumbnail_" +
						parseInt(combinationImages[id_product_attribute][i]),
				).show();
	} else $("#thumbs_list li").show();

	if (
		parseInt($("#thumbs_list_frame >li:visible").length) !=
		parseInt($("#thumbs_list_frame >li").length)
	)
		$("#wrapResetImages").stop(true, true).show();
	else $("#wrapResetImages").stop(true, true).hide();

	$("#thumbs_list").trigger("goto", 0);
	serialScrollFixLock("", "", "", "", 0);
}

function saveCustomization() {
	$("#quantityBackup").val($("#quantity_wanted").val());
	$("#customizationForm").submit();
}

function submitPublishProduct(url, redirect, token) {
	var id_product = $("#admin-action-product-id").val();

	$.ajaxSetup({
		async: false,
	});
	$.post(
		url + "/index.php",
		{
			action: "publishProduct",
			id_product: id_product,
			status: 1,
			redirect: redirect,
			ajax: 1,
			tab: "AdminProducts",
			token: token,
		},
		function (data) {
			if (data.indexOf("error") === -1) document.location.href = data;
		},
	);
	return true;
}

function checkMinimalQuantity(minimal_quantity) {
	if ($("#quantity_wanted").val() < minimal_quantity) {
		$("#quantity_wanted").css("border", "1px solid red");
		$("#minimal_quantity_wanted_p").css("color", "red");
	} else {
		$("#quantity_wanted").css("border", "1px solid #BDC2C9");
		$("#minimal_quantity_wanted_p").css("color", "#374853");
	}
}

function colorPickerClick(elt) {
	id_attribute = $(elt).attr("id").replace("color_", "");
	$(elt).parent().parent().children().removeClass("selected");
	$(elt).fadeTo("fast", 1, function () {
		$(this).fadeTo("fast", 0, function () {
			$(this).fadeTo("fast", 1, function () {
				$(this).parent().addClass("selected");
			});
		});
	});
	$(elt)
		.parent()
		.parent()
		.parent()
		.children(".color_pick_hidden")
		.val(id_attribute);

	findCombination();
}

function getProductAttribute() {
	// get every attributes values
	request = "";
	//create a temporary 'tab_attributes' array containing the choices of the customer
	var tab_attributes = [];
	var radio_inputs = parseInt(
		$("#attributes .checked > input[type=radio]").length,
	);
	if (radio_inputs) radio_inputs = "#attributes .checked > input[type=radio]";
	else radio_inputs = "#attributes input[type=radio]:checked";

	$(
		"#attributes select, #attributes input[type=hidden], " + radio_inputs,
	).each(function () {
		tab_attributes.push($(this).val());
	});

	// build new request
	for (var i in attributesCombinations)
		for (var a in tab_attributes)
			if (attributesCombinations[i]["id_attribute"] === tab_attributes[a])
				request +=
					"/" +
					attributesCombinations[i]["group"] +
					attribute_anchor_separator +
					attributesCombinations[i]["attribute"];
	request = request.replace(request.substring(0, 1), "#/");
	var url = window.location + "";

	// redirection
	if (url.indexOf("#") != -1) url = url.substring(0, url.indexOf("#"));

	if ($("#customizationForm").length) {
		// set ipa to the customization form
		customAction = $("#customizationForm").attr("action");
		if (customAction.indexOf("#") != -1)
			customAction = customAction.substring(0, customAction.indexOf("#"));
		$("#customizationForm").attr("action", customAction + request);
	}

	window.location = url + request;
}

function initLocationChange(time) {
	if (!time) time = 500;
	setInterval(checkUrl, time);
}

// ANCHOR Préselection des attributs en fonction de l'url
function checkUrl() {
	if (original_url != window.location || first_url_check) {
		first_url_check = false;
		var url = window.location + "";
		// if we need to load a specific combination
		if (url.indexOf("#/") != -1) {
			// get the params to fill from a "normal" url
			params = url.substring(url.indexOf("#") + 1, url.length);
			tabParams = params.split("/");
			tabValues = [];
			if (tabParams[0] == "") tabParams.shift();
			for (var i in tabParams)
				tabValues.push(tabParams[i].split(attribute_anchor_separator));
			// fill html with values
			$(".color_pick")
				.removeClass("selected")
				.parent()
				.parent()
				.children()
				.removeClass("selected");

			count = 0;

			// On cherche l'attribut correspondant qui possède la valeur choisie
			for (var z in tabValues) {
				for (var a in attributesCombinations) {
					if (
						attributesCombinations[a]["group"] ===
							decodeURIComponent(tabValues[z][0]) &&
						attributesCombinations[a]["attribute"] ===
							decodeURIComponent(tabValues[z][1])
					) {
						count++;

						var desiredValueGroup =
							attributesCombinations[a]["id_attribute_group"];
						var desiredValue =
							attributesCombinations[a]["id_attribute"];

						// add class 'selected' to the selected color
						$("#color_" + desiredValue)
							.addClass("selected")
							.parent()
							.addClass("selected");

						// Input Radio
						$("input:radio[value=" + desiredValue + "]").attr(
							"checked",
							true,
						);

						// Champs masqués
						$(
							"input[type=hidden][name=group_" +
								desiredValueGroup +
								"]",
						).val(desiredValue);

						// Select
						var optionGroupSelect = $(
							"select[name=group_" + desiredValueGroup + "]",
						);

						// Check if the select contains an option with the desired value
						if (
							optionGroupSelect.find(
								'option[value="' + desiredValue + '"]',
							).length
						) {
							// If the option exists, set the value
							optionGroupSelect.val(desiredValue);
						} else {
							// If the option doesn't exist, handle the situation here
							console.warn(
								"Option with value " +
									desiredValue +
									" doesn't exist in the select",
							);
							// You can add your logic or error handling here
						}
					}
				}
			}

			// find combination and select corresponding thumbs
			if (count >= 0) {
				firstTime = false;
				findCombination();
				original_url = url;
				return true;
			} else {
				// no combination found = removing attributes from url
				window.location = url.substring(0, url.indexOf("#"));
			}
		}
	}
	return false;
}

$(document).ready(function () {
	$("#thumbs_list img").css("visibility", "visible");

	$(".blockcart").removeClass("almosthide");

	$(".mt-active, .right-column, #thumbs_list ul li").addClass(
		"bgtransparent",
	);
	$(".page-container").removeClass("loading");
});

$(document).on("keyup keypress", "#buy_block input", function (e) {
	if (e.keyCode == 13) {
		e.preventDefault();
		return false;
	}
});

function selectAttributeByCombinationId(combination_id) {
	if (typeof combinationsFromController[combination_id] == "undefined")
		return false;

	var c = combinationsFromController[combination_id];
	var i = 0;
	c.attribute_select = [];

	$.each(c.attributes_values, function (k) {
		c.attribute_select[k] = c.attributes[i];
		i++;
	});

	$(".color_pick").removeClass("selected").parent().removeClass("selected");
	$.each(c.attribute_select, function (k, v) {
		$("#color_" + v)
			.addClass("selected")
			.parent()
			.addClass("selected");
		$("input:radio[value=" + v + "]").prop("checked", true);
		$("input[type=hidden][name=group_" + k + "]").val(v);
		$("select[name=group_" + k + "]").val(v);
	});

	findCombination();
	refreshProductImages(0);
}

function changeDefaultCombinationIfNotAvailable() {
	if (
		typeof combinationsFromController == "undefined" ||
		window.location.href.indexOf("#/") > -1
	)
		return false;

	if (combinationsFromController) {
		$.each(combinationsFromController, function (k, v) {
			if (v.quantity > 0 && !v.unavailable) {
				selectAttributeByCombinationId(k);
				return false;
			}
		});
	}
}

$(document).ready(function () {
	$(".pb-right-column").responsiveDom({
		appendTo: ".mobile-structure",
		mediaQuery: "(max-width: 1199px)",
		callback: function (mediaMatched) {
			if (mediaMatched) {
				$(".pb-left-column").show();
				$(".contBtn.box-cart-bottom")
					.clone()
					.appendTo("body")
					.addClass("fixedBottom");
				$(".fixedBottom").headroom({
					offset: 700,
					tolerance: {
						up: 5,
						down: 0,
					},
				});
			}
		},
	});

	// Select all links with hashes
	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function (event) {
			// On-page links
			if (
				location.pathname.replace(/^\//, "") ==
					this.pathname.replace(/^\//, "") &&
				location.hostname == this.hostname
			) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length
					? target
					: $("[name=" + this.hash.slice(1) + "]");
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$("html, body").animate(
						{
							scrollTop: target.offset().top,
						},
						1000,
						function () {
							// Callback after animation
							// Must change focus!
							var $target = $(target);
							$target.focus();
							if ($target.is(":focus")) {
								// Checking if the target was focused
								return false;
							} else {
								$target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
								$target.focus(); // Set focus again
							}
						},
					);
				}
			}
		});

	(function ($) {
		$.fn.hasScrollBar = function () {
			return this.get(0).scrollWidth > this.width();
		};
	})(jQuery);

	$("#thumbs_list").each(function () {
		var $carousel = $(this),
			$carouselList = $carousel.find("#thumbs_list_frame"),
			$carouselItem = $carousel.find("#thumbs_list_frame>li"),
			$carouselButton = $carousel.find(".js-carousel-button"),
			slide = function () {
				var $button = $(this),
					dir = $button.data("dir"),
					curPos = parseInt($carouselList.scrollLeft()) || 0,
					moveto = 0,
					containerWidth = $carousel.outerWidth();
				if (dir == "next") {
					moveto =
						curPos +
						($carousel.outerWidth() -
							$carouselItem.outerWidth() / 2);
				} else {
					moveto =
						curPos -
						($carousel.outerWidth() -
							$carouselItem.outerWidth() / 2);
				}

				$carouselList.animate(
					{
						scrollLeft: moveto,
					},
					{
						duration: 500,
						complete: function () {},
					},
				);
			};

		if (
			$carousel.first("#thumbs_list_frame").hasScrollBar() ||
			$("#thumbs_list_frame li").length > 6
		) {
			$carousel.find(".carousel__button--next").show();
		}

		$carouselButton.on("click", slide);

		var lastScrollLeft = 0;
		$carousel.find(".carousel__button--prev").hide();
		$carouselList.scroll(function () {
			var documentScrollLeft = $carouselList.scrollLeft();
			if (lastScrollLeft != documentScrollLeft)
				lastScrollLeft = documentScrollLeft;

			if (documentScrollLeft === 0) {
				$carousel.find(".carousel__button--prev").hide();
			} else {
				$carousel.find(".carousel__button--prev").show();
			}

			if (
				$carouselList[0].scrollWidth - $carousel.outerWidth() ===
				documentScrollLeft
			) {
				$carousel.find(".carousel__button--next").hide();
			} else {
				$carousel.find(".carousel__button--next").show();
			}
		});
	});
});

// ANCHOR SWIPER

jQuery(document).ready(function ($) {
	$(".reassurance a, #AV_button2, .popincool").hover(
		function () {
			var lili = this;
			window.mytimeout = setTimeout(function () {
				$(lili).find(".popincool").first().css({
					visibility: "visible",
					opacity: "1",
				});
			}, 250);
		},
		function () {
			var lili = this;

			clearTimeout(window.mytimeout);

			window.mytimeout = setTimeout(function () {
				$(lili).find(".popincool").first().css({
					visibility: "hidden",
					opacity: "0",
				});
			}, 350);
		},
	);
});

jQuery(document).ready(function () {
	// This button will increment the value
	$('[data-quantity="plus"]').click(function (e) {
		// Stop acting like a button
		e.preventDefault();
		// Get the field name
		fieldName = $(this).attr("data-field");
		// Get its current value
		var currentVal = parseInt($("input[name=" + fieldName + "]").val());
		// If is not undefined
		if (!isNaN(currentVal)) {
			// Increment
			$("input[name=" + fieldName + "]").val(currentVal + 1);
		} else {
			// Otherwise put a 0 there
			$("input[name=" + fieldName + "]").val(0);
		}
	});
	// This button will decrement the value till 0
	$('[data-quantity="minus"]').click(function (e) {
		// Stop acting like a button
		e.preventDefault();
		// Get the field name
		fieldName = $(this).attr("data-field");
		// Get its current value
		var currentVal = parseInt($("input[name=" + fieldName + "]").val());
		// If it isn't undefined or its greater than 0
		if (!isNaN(currentVal) && currentVal > 1) {
			// Decrement one
			$("input[name=" + fieldName + "]").val(currentVal - 1);
		} else {
			// Otherwise put a 0 there
			$("input[name=" + fieldName + "]").val(1);
		}
	});
});

// Au clic sur "+ de détails"
$(".product-details-link").on("click", function (event) {
	event.preventDefault();
	$([document.documentElement, document.body]).animate(
		{
			scrollTop: $("#detailed-description").offset().top,
		},
		1000,
	);
	$("#detailed-description").collapse("show");
});

function clickOnAvis() {
	$("#comments").collapse("show");
}

// ANCHOR Si on sélectionne un magasin avec du stock, et qu'on avait cliqué sur "Ajouter au panier", déclenchement d'ajout au panier
var addToCartClicked = false;

$("#add-to-cart-after-select").on("click", function () {
	addToCartClicked = true;
});

$(".store-option").on("click", function () {
	getProductAttribute();
	if (addToCartClicked) {
		if ($(this).hasClass("store-has-stock")) {
			$(".submit-store-selection").addClass("submit-add-cart");
		} else {
			$(".submit-store-selection").removeClass("submit-add-cart");
		}
	}
});

// ANCHOR CRITEO Script "Produit"
function setCriteoScriptForProduct() {
	// CRITEO Reset dataLayer ecommerce
	window.dataLayer = window.dataLayer || [];

	if (
		dataLayer.some(
			(item) =>
				item.event === "i_havecookies_activate" &&
				item.consent.analytics === "true",
		)
	) {
		dataLayer.push({ ecommerce: null });
	}

	let elementId = $("#product_page_product_id").val();

	if (elementId) {
		let elementPriceContainer = document.querySelector(
			'meta[itemprop="price"]',
		);
		let elementPriceValue = parseFloat(
			elementPriceContainer.getAttribute("content"),
		);
		let elementBrand = document
			.querySelector(".product-brand-name")
			.textContent.trim();
		let elementName = document
			.querySelector(".titreProduit")
			.textContent.trim();
		let elementCategoryContainer = document.querySelector(
			'meta[itemprop="category"]',
		);
		let elementCategoryValue =
			elementCategoryContainer.getAttribute("content");

		let dataLayerProduct = {
			name: elementName,
			id: elementId,
			price: elementPriceValue,
			brand: elementBrand,
			category: elementCategoryValue,
		};

		if (selectedCombination && selectedCombination.reference_y2)
			dataLayerProduct["variant"] = selectedCombination.reference_y2;

		// CRITEO Script Product viewed in list
		if (
			dataLayer.some(
				(item) =>
					item.event === "i_havecookies_activate" &&
					item.consent.analytics === "true",
			)
		) {
			dataLayer.push({
				event: "view_item",
				ecommerce: {
					detail: {
						products: [dataLayerProduct],
					},
				},
			});
		}
	}
}

function handleIntersectionTooltipVeloTest(entries, observer) {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			// Schedule hiding the tooltip after 2500 milliseconds
			setTimeout(() => {
				$(".product-available-test .stores-with-stock").tooltip("hide");
			}, 4500);

			// Disconnect the observer to stop further observations
			observer.disconnect();
		}
	});
}

// Options for the Intersection Observer
const observerOptions = {
	root: null, // Use the viewport as the root
	threshold: 0.5, // Trigger when 50% of the target is visible
};
